__turbopack_context__.v({
  "button": "index-module-scss-module__H-52RW__button",
  "button-dialog": "index-module-scss-module__H-52RW__button-dialog",
  "button-group": "index-module-scss-module__H-52RW__button-group",
  "close-btn": "index-module-scss-module__H-52RW__close-btn",
  "horizonal": "index-module-scss-module__H-52RW__horizonal",
  "is-loading": "index-module-scss-module__H-52RW__is-loading",
  "message": "index-module-scss-module__H-52RW__message",
  "negative-btn": "index-module-scss-module__H-52RW__negative-btn",
  "positive-btn": "index-module-scss-module__H-52RW__positive-btn",
  "title": "index-module-scss-module__H-52RW__title",
});
